const actionTypeIdentifier = '9851458E-700C-4552-A6B3-100FBE5C93D5'; //this is a newid

export const getGLCode = `GET-GL-CODE-${actionTypeIdentifier}`;
export const setGLCodeError = `SET-GL-CODE-ERROR-${actionTypeIdentifier}`;
export const setGLCodeColSearchStr = `SET-GL-CODE-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const sortGLCodeItems = `SORT-GL-CODE-${actionTypeIdentifier}`;
export const setGLCodePageSize = `SET-GL-CODE-PAGESIZE-${actionTypeIdentifier}`;
export const setGLCodeFilter = `SET-GL-CODE-FILTER-${actionTypeIdentifier}`;
export const applyGLCodeFilter = `APPLY-GL-CODE-FILTER-${actionTypeIdentifier}`;
export const setDefaultGLCode = `SET-DEFAULT-GL-CODE-${actionTypeIdentifier}`;